export const emptyPipelineFilters = () => ({
  deal_status: 'all',
  date_field: 'created',
  period: '',
  date_from: '',
  date_to: '',
  assignee_ids: [],
  stage_names: [],
  value_min: '',
  value_max: '',
  closed_by_id: '',
  loss_reason: '',
  source: '',
  campaign: '',
  product: '',
  inactive_days: '',
  stage_days: '',
  activity: '',
});

export const pipelinePreset = name => {
  const filters = emptyPipelineFilters();
  if (name === 'mine') {
    return { ...filters, deal_status: 'open', assignee_ids: ['me'] };
  }
  return {
    ...filters,
    deal_status: { won: 'won', lost: 'lost', new: 'all' }[name] || 'all',
    date_field: name === 'new' ? 'created' : 'closed',
    period: 'today',
  };
};

export const pipelineParams = filters => ({
  ...filters,
  assignee_ids: undefined,
  assignee_id: filters.assignee_ids.join(','),
  stage_names: filters.stage_names.join(','),
  date_from: filters.period ? undefined : filters.date_from,
  date_to: filters.period ? undefined : filters.date_to,
});
